import axios from 'axios';

export const searchLocation = async (query: string) => {
  const response = await axios.get('https://dapi.kakao.com/v2/local/search/keyword.json', {
    params: {
      query
    },
    headers: {
      Authorization: `KakaoAK ${import.meta.env.REACT_APP_KAKAO_REST_API_KEY}` // 🔒 여기에 본인 키 입력!
    }
  });
  return response.data;
};
